import React, { useState, useEffect } from "react";

import { ReportTitleWrap } from "./styles";

// redux
import { useSelector, useDispatch } from "react-redux";

// helpers
import { siftActions } from "../../../Redux";

const ReportTitle = () => {
  const dispatch = useDispatch();
  const reportData = useSelector((state) => state.sift.ioManager.report.reportData);

  const [addressInputToggle, setAddressInputToggle] = useState(false);

  useEffect(() => {
    if (addressInputToggle) {
      document.querySelector("#address-input").focus();
    }
  }, [addressInputToggle]);

  return (
    <ReportTitleWrap>
      <h1>{`${!_.isEmpty(reportData.project_name) ? reportData.project_name : "Solar Project"}`}</h1>
      <div className="address-box">
        {addressInputToggle ? (
          <input
            id="address-input"
            type="text"
            value={reportData.address}
            onBlur={() => setAddressInputToggle(!addressInputToggle)}
            onChange={(e) => dispatch(siftActions.updateReportData("address", e.target.value))}
            onKeyDown={(e) => e.keyCode === 13 && setAddressInputToggle(!addressInputToggle)}
          />
        ) : reportData.address ? (
          <p>{`${reportData.address}`}</p>
        ) : (
          <p>Add Address</p>
        )}
        <svg onClick={() => setAddressInputToggle(!addressInputToggle)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="https://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 18V11H18V18H2V2H9V0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18ZM17.1781 0.723423C16.7197 0.26142 16.0921 0 15.4374 0C14.7834 0 14.1564 0.26083 13.6954 0.724628L5.3265 9.09342C4.57867 9.75233 4.08844 10.7328 4.00325 11.7873L4 15.0023V16.0023H8.1346C9.2689 15.9245 10.259 15.4295 10.9575 14.6238L19.279 6.30584C19.7407 5.84416 20.0001 5.21799 20.0001 4.56508C20.0001 3.91217 19.7407 3.286 19.279 2.82432L17.1781 0.723423ZM8.06398 14.0048C8.59821 13.967 9.09549 13.7184 9.49479 13.2616L15.5567 7.19972L12.8024 4.44527L6.6961 10.5496C6.29095 10.9079 6.04031 11.4092 6 11.8678V14.0029L8.06398 14.0048ZM14.2169 3.03128L16.9709 5.78551L17.8648 4.89162C17.9514 4.80502 18.0001 4.68756 18.0001 4.56508C18.0001 4.4426 17.9514 4.32514 17.8648 4.23854L15.7611 2.13486C15.6755 2.04855 15.5589 2 15.4374 2C15.3158 2 15.1992 2.04855 15.1136 2.13486L14.2169 3.03128Z"
            fill="var(--primary-brand-color)"
          />
        </svg>
      </div>
    </ReportTitleWrap>
  );
};

export { ReportTitle };
